import { useSiteStore } from '~/stores/site.store';
import { globalKeys } from 'assets/data/global-keys';
import {
  contentRoutes,
  loginRoutes,
  partnerRoutes,
  registerRoutes,
  systemRoutes,
} from 'assets/data/config';
import { useAuthStore } from '~/stores/auth.store';
import { useStorageService } from '~/composables/services/useStorageService';
import { getCampaignRoutes } from '~/utilities/campaign-utils';

export default defineNuxtRouteMiddleware((to, from) => {
  const $storageService = useStorageService();
  const { $trackRouteChange } = useNuxtApp();
  const auth = useAuthStore();
  const siteStore = useSiteStore();
  const errorExclusions = [
    ...contentRoutes,
    ...systemRoutes,
    ...loginRoutes,
    ...registerRoutes,
    ...partnerRoutes,
    ...getCampaignRoutes(),
  ];

  $trackRouteChange({ to: to?.fullPath, from: from?.fullPath });

  if (!!to.params?.game && siteStore.isWebview) return abortNavigation();

  const page = computed(() => {
    if (to.params.contentType === 'home' || to.path === '/')
      return siteStore.getSitemapMap.get(`/`);
    if (
      ['terms-and-conditions', 'privacy-policy', 'faq'].includes(
        String(to.name),
      )
    )
      return siteStore.getSitemapMap.get(`/${String(to.name)}`);
    return siteStore.getSitemapMap.get(`/${String(to.params.contentType)}`);
  });
  if (auth?.isLoggedIn) {
    if (to.fullPath === '/') {
      if (!!from?.fullPath && from.fullPath !== '/') {
        $storageService.removeCookies([
          globalKeys.navigationKeys.lastRoute(auth?.userId),
          globalKeys.navigationKeys.lastVertical(auth?.userId),
          globalKeys.navigationKeys.lastCategory(auth?.userId),
        ]);
      }
    } else {
      $storageService.setCookie({
        key: globalKeys.navigationKeys.lastRoute(auth?.userId),
        data: to.path,
        expiry: 7,
      });
      if (!!to.params.contentType && page.value?.isVertical)
        $storageService.setCookie({
          key: globalKeys.navigationKeys.lastVertical(auth?.userId),
          data: to.params.contentType,
          expiry: 7,
        });
      if (!!to.params.category)
        $storageService.setCookie({
          key: globalKeys.navigationKeys.lastCategory(auth?.userId),
          data: to.params.category,
          expiry: 7,
        });
    }
  }

  if (
    typeof page.value === 'undefined' &&
    !errorExclusions.some((e) => to.fullPath.startsWith(e)) &&
    siteStore.getSitemapMap.size !== 0
  )
    showError({
      statusCode: 404,
      statusMessage: 'Page Not Found',
      fatal: false,
      unhandled: false,
    });
});
